import * as React from 'react';
import Select from '../../elements/Select';

import {Card} from '../../elements';


import {usePlanContext} from '../../context/PlanContext';
import { SelectStyled } from '../../elements/forms/InputContainer';
import { Controller, useFormContext } from 'react-hook-form';
import { SelectContainer } from '../../components/accounts/AccountContainer.style'
import { PlanFormValues } from './PlanFormInfo.type';

export function PlanFormExternalPlansComponent() : JSX.Element {

  const {
    externalPlans,
    externalPlansOptions,
    handleChange,
    externalStoreEnabled,
  } = usePlanContext();
  const {control, formState: {errors}} = useFormContext<PlanFormValues>();

  return(
      <div className="row">
        <div className="col s12">
          <Card title={'Cobranças recorrente e automática'}>
          {externalStoreEnabled ? 
          (<>
            <div className="row">
              <div className="col s12">
              <Controller
              name="externalPlans"
              control={control}
              render={({field, field: {value}}) => (
                <SelectContainer className="col s12">
                  <SelectStyled
                    {...field}
                    onChange={(provider: any) => {
                      field.onChange([...field.value, provider.value]);
                    }}
                    value={externalPlansOptions.find((provider: any) => provider.value === value)}
                    label="Selecione os provedores que quer conectar"
                    placeholder="Digite/Selecione um provedor"
                    options={externalPlansOptions}
                    selectType="select2"
                    />
                </SelectContainer>
              )}
            />
                </div>
            </div>
            {externalPlansOptions.length < 2 && (
              <div className="row">
                <div className="col s12">
                  <p>Se quiser adicionar um novo provedor de pagamento, acesse as configurações de sua conta na opção "Pagamentos"</p>
                </div>
              </div>
            )}
          </>) : (
            <div className="row">
              <div className="col s12">
                <p>Você não tem nenhum provedor para pagamentos on-line conectado à sua conta. Acesse suas configurações de sua conta na opção "Pagamentos" para cadastrar.</p>
                <p>Ou se quiser, contacte nosso time para te ajudar.</p>
              </div>
            </div>
          )
          }
          </Card>
        </div>
      </div>
  )
}